module.exports = __webpack_public_path__ + "media/images/features/4/location-1-b6d9ac33fe9ddde71fbeae8c42db1379.jpg";